// extracted by mini-css-extract-plugin
export var dataCell = "_rf-2";
export var dataRow = "_rf-0";
export var headerRow = "_rf-1";